import React from 'react'
import { Email, Phone } from '@mui/icons-material';
import { useAppData } from '../../../../../../context/AppDataContext';


function LatterHead({companyDetails}) {
    const {getMasterLabel, partyDD, ledgerDD,getDDDataById} = useAppData()
    return (
        companyDetails &&
        <div className='row'>
            <div className='col-6'>
                <div className=''>
                    <div className='fw-bold' style={{ fontSize: 28 }}>{companyDetails.companyName}</div>
                    <div style={{fontSize:12}}>{companyDetails.address}</div>
                    <div style={{fontSize:12}}>{companyDetails.city}, {getMasterLabel("indian-state", companyDetails.state)} - {companyDetails.zip}</div>
                </div>
            </div>
            <div className='col-6'>
                <div className='float-end'>
                    {companyDetails.logo !== null && companyDetails.logo !== "" &&
                        <div>
                            <img src={companyDetails.logo} style={{maxWidth:"100%", maxHeight:".5in"}} />
                        </div>    
                    }
                    <div>
                        <span >
                            <Email style={{ fontSize: 14 }} /> {companyDetails.email} 
                        </span>
                    </div>
                    <div >
                        <span >
                            <Phone style={{ fontSize: 14 }} /> {companyDetails.phone}
                        </span>
                    </div>
                </div>
            </div>
            <hr/>
        </div>
    )
}

export default LatterHead